const timelineRows = [
  {
    time: '9:47 am',
    text: 'You open a file to "just check something real quick." Standup is at 10:00. Plenty of time.',
    highlight: false,
  },
  {
    time: '9:49 am',
    text: 'The thing you were checking points to another thing. You follow the thread. The IDE feels like the only room that exists.',
    highlight: false,
  },
  {
    time: '~9:53 am',
    text: '<strong>You have left the present.</strong> Working memory fills completely. External time signals fall below the threshold of perception.',
    highlight: true,
  },
  {
    time: '10:00 am',
    text: "Somewhere across a bridge, your name is called. Someone says \"maybe he's running late\" and moves on.",
    highlight: false,
  },
  {
    time: '10:28 am',
    text: 'You surface. Bug is fixed — or at least different. <strong>One Slack: "Hey, you missed standup."</strong>',
    highlight: false,
  },
  {
    time: '10:29 am',
    text: 'You type "sorry, lost track of time" for the forty-seventh time in your career.',
    highlight: false,
  },
];

export default function DialBackPain() {
  return (
    <section
      className="py-28 px-12 border-t border-white/5 max-md:px-6 max-md:py-20"
      style={{ background: '#0e0d0b', fontFamily: "'Instrument Sans', sans-serif" }}
    >
      <div className="max-w-[1200px] mx-auto">
        {/* Label */}
        <div
          className="flex items-center gap-3 mb-4"
          style={{ fontFamily: "'DM Mono', monospace", fontSize: '11px', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#c8472a' }}
        >
          <span className="block w-6 h-px bg-[#c8472a]" />
          The problem
        </div>

        <h2
          className="font-light leading-[1.1] text-[#f5f2ec] mb-0"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}
        >
          Flow state doesn&apos;t respect<br />
          your <em className="italic text-[#c8472a]">10:00 am block</em>
        </h2>

        <div className="grid grid-cols-2 gap-20 mt-16 max-md:grid-cols-1 max-md:gap-12">
          {/* Copy */}
          <div className="space-y-5">
            {[
              <>You weren&apos;t ignoring the meeting. You weren&apos;t being difficult. You were somewhere else entirely — somewhere without clocks, without Slack pings, without the faint background hum of organizational obligation. <strong className="text-[#f5f2ec] font-semibold">You were time traveling.</strong></>,
              <>Psychologists call it a flow state — full cognitive immersion where self-consciousness recedes and time perception collapses. The very thing that makes a great engineer is the same thing that makes calendar management structurally impossible.</>,
              <>How many times has a colleague called you directly — on a completely separate line — just to alert you the meeting started? And how many times did you answer and ask: <strong className="text-[#f5f2ec] font-semibold">which meeting? Can you send me the link?</strong> You were that deep.</>,
              <>That colleague is patient. But that is not their job. And the next time, they may just let it go.</>,
            ].map((para, i) => (
              <p key={i} className="text-[1.05rem] leading-[1.8] text-[rgba(245,242,236,0.7)]">
                {para}
              </p>
            ))}
          </div>

          {/* Timeline */}
          <div className="border border-white/[0.08] rounded-[4px] overflow-hidden">
            <div
              className="px-[18px] py-3 bg-white/[0.03] border-b border-white/[0.06] text-[#9a9488]"
              style={{ fontFamily: "'DM Mono', monospace", fontSize: '10px', letterSpacing: '0.18em', textTransform: 'uppercase' }}
            >
              A field report — what time travel actually looks like
            </div>
            {timelineRows.map((row, i) => (
              <div
                key={i}
                className={`flex gap-4 px-[18px] py-[14px] border-b border-white/[0.04] last:border-b-0 transition-colors duration-200 hover:bg-white/[0.02] ${
                  row.highlight ? 'bg-[rgba(200,71,42,0.06)] border-l-2 border-l-[#c8472a]' : ''
                }`}
              >
                <div
                  className="text-[#9a9488] min-w-[56px] pt-[3px]"
                  style={{ fontFamily: "'DM Mono', monospace", fontSize: '10px', letterSpacing: '0.04em' }}
                >
                  {row.time}
                </div>
                <div
                  className="text-[0.88rem] text-[rgba(245,242,236,0.75)] leading-[1.55]"
                  dangerouslySetInnerHTML={{ __html: row.text.replace(/<strong>/g, '<strong style="color:#f5f2ec;font-weight:600">') }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
